/**
 * Pack validity is measured in IST CALENDAR DAYS, expiry inclusive — a pack is
 * usable for the whole of its last day.
 *
 * A bare `new Date(expiry) <= now` is only equivalent while every expiry is
 * stored at 23:59:59.999 IST. An admin-edited expiry used to land at 05:30 IST,
 * and such a pack read as expired mid-morning on a day it could still be booked
 * — the backend now normalises on write, but comparing by day means this never
 * depends on that.
 */
export function isExpiredBeforeToday(
  expiry?: string | Date | null,
  now: Date = new Date(),
): boolean {
  if (!expiry) return false;
  const e = new Date(expiry);
  if (isNaN(e.getTime())) return false;
  const expiryDay = new Date(e.getFullYear(), e.getMonth(), e.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return expiryDay.getTime() < today.getTime();
}
